import React, { useState, useRef } from 'react';
import { createQuery } from '../api';
import Modal from './Modal';
import CategorySelect from './CategorySelect';
import DarkInput from './DarkInput';
import SqlEditor from './SqlEditor';
import FormLabel from './FormLabel';
import ErrorBanner from './ErrorBanner';
import PremiumToggle from './PremiumToggle';
import GradientButton from './GradientButton';
import GhostButton from './GhostButton';

const EMPTY = { category: '', subcategory: '', query_name: '', is_premium: false, sql_query: '' };

function CreateQueryForm({ onClose, onCreated }) {
  const [form, setForm]             = useState(EMPTY);
  const [error, setError]           = useState('');
  const [submitting, setSubmitting] = useState(false);
  const fileRef                     = useRef(null);

  function set(patch) { setForm(f => ({ ...f, ...patch })); }

  function handleFile(e) {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => set({
      sql_query: ev.target.result,
      query_name: form.query_name.trim() ? form.query_name : file.name.replace(/\.sql$/i, ''),
    });
    reader.readAsText(file); e.target.value = '';
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.category.trim())   { setError('Category is required.');   return; }
    if (!form.query_name.trim()) { setError('Query name is required.'); return; }
    if (!form.sql_query.trim())  { setError('SQL is required.');        return; }
    setSubmitting(true); setError('');
    try {
      await createQuery(form);
      onCreated(); onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-2">

      <CategorySelect
        category={form.category} subcategory={form.subcategory}
        onChange={set} autoSelectFirst
      />

      <div>
        <FormLabel>Query Name</FormLabel>
        <DarkInput
          type="text" placeholder="e.g. gl_journal_entries"
          value={form.query_name} onChange={e => set({ query_name: e.target.value })}
          style={{ fontFamily: "'Courier New', monospace" }}
        />
      </div>

      <PremiumToggle value={form.is_premium} onChange={() => set({ is_premium: !form.is_premium })} />

      <div style={{ borderTop: '1px solid #1e2130', paddingTop: '8px' }}>
        <FormLabel>SQL Query</FormLabel>
        <SqlEditor
          value={form.sql_query} onChange={e => set({ sql_query: e.target.value })}
          fileInputRef={fileRef} onFileUpload={handleFile}
          minRows={2}
        />
      </div>

      <ErrorBanner message={error} />
      <div className="flex justify-end gap-3 pt-1">
        <GhostButton type="button" onClick={onClose}>Cancel</GhostButton>
        <GradientButton type="submit" disabled={submitting}>
          {submitting ? 'Creating…' : 'Create Query'}
        </GradientButton>
      </div>
    </form>
  );
}

export default function CreateQueryModal({ onClose, onCreated }) {
  return (
    <Modal title="New Query" onClose={onClose} maxWidth="max-w-xl">
      <CreateQueryForm onClose={onClose} onCreated={onCreated} />
    </Modal>
  );
}
